import React from "react";
import Card from "react-bootstrap/Card";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row } from "react-bootstrap";
import { images } from "../../../../constants";

// JSON with full step-by-step info
export const BusinessDatathree = [
  {
    id: 1,
    title: "Gems & Jewelry Markets",
    para: "Explore jewelry and precious stones",
    info: (
      <>
        <p>
          The <strong>Gems and Jewelry Platform</strong> is a specialized market
          where users can search for shops offering{" "}
          <strong>jewelry and precious stones</strong>.
        </p>
        <p>
          On this platform, users can explore and discover shops that sell{" "}
          <strong>gold, silver, diamond jewelry</strong>, and other precious or
          semi-precious stones. It allows customers to browse collections,
          compare designs, and choose a jeweler according to their preferences.
        </p>
        <p>
          The <strong>Gems and Jewelry Platform</strong> makes it easy for users
          to find trusted jewelry shops and desired precious items in one
          dedicated marketplace.
        </p>
        <a href="https://www.youtube.com" target="_blank">
          <strong>Click here to see how to Explore the Market</strong>
        </a>
      </>
    ),
  },
  {
    id: 2,
    title: "2nd Hand Item Markets",
    para: "Find pre-owned or second-hand items",
    info: (
      <>
        <p>
          The <strong>2nd Hand Items platform</strong> is a dedicated
          marketplace for shops that sell{" "}
          <strong>pre-owned or used items</strong>.
        </p>
        <p>
          Users can easily search and find shop showcases to view available
          second-hand products, such as{" "}
          <strong>electronics, furniture, vehicles, clothing</strong>, and other
          reusable goods. This allows users to explore products, compare
          options, and make informed purchasing decisions from the comfort of
          their home.
        </p>
        <p>
          The <strong>2nd Hand Items platform</strong> promotes affordable
          shopping, reuse, and sustainability by connecting buyers with trusted
          second-hand item sellers.
        </p>
        <a href="https://www.youtube.com" target="_blank">
          <strong>Click here to see how to Explore the Market</strong>
        </a>
      </>
    ),
  },
  {
    id: 3,
    title: "HomeMade Markets",
    para: "Promote and sell homemade products",
    info: (
      <>
        <p>
          The <strong>Homemade Market</strong> is a platform where users can
          create a shop showcase for their <strong>homemade products</strong>.
        </p>
        <p>
          On this platform, users can sell homemade items directly to customers
          or through the retail market. It is especially beneficial for
          individuals involved in <strong>home-based businesses, crafts</strong>
          , and small or cottage industries.
        </p>
        <p>
          The <strong>Homemade Market</strong> provides an excellent opportunity
          for creators and entrepreneurs to promote their handmade products,
          reach more customers, and grow their business from home.
        </p>
        <a href="https://www.youtube.com" target="_blank">
          <strong>Click here to see how to Explore the Market</strong>
        </a>
      </>
    ),
  },
];

const Shops = ({ btn }) => {
  return (
    <div>
      <Row className="set-one">
        {BusinessDatathree.map((data) => (
          <Col
            key={data.id}
            lg={4}
            md={4}
            sm={6}
            xs={6}
          >
            {/* CardNav shows title + full info */}
            <CardNav
              Header={data.title}
              para={data.para}
              myinfo={data.info}
              myid={data.id}
            />

            <Card className="shadow-main mt-2">
              {data.id === 1 ? (
                <BoxData
                  Title="Gems & Jewelry"
                  Butonn={btn}
                  imgg={images.GemStone}
                  url="/gems-integrate"
                  link="/buy-Minerals"
                  ms="eleven-element"
                  buy="eleven"
                />
              ) : data.id === 2 ? (
                <BoxData
                  Title="2nd Hand Items"
                  Butonn={btn}
                  imgg={images.UsedItems}
                  url="/useditems-integrate"
                  link="/buy-used-products"
                  ms="twelve-element"
                  buy="twelve"
                />
              ) : (
                <BoxData
                  Title="HomeMade Items"
                  Butonn={btn}
                  imgg={images.Homemade}
                  url="/homemade-integrate"
                  link="/buy-homemade-products"
                  ms="thirteen-element"
                  buy="thirteen"
                />
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Shops;
